import initStore from '@/stores/init';
import agentStore from '@/stores/agent';
import { bridgeCallFunc } from '@/utils/instantLoaded/tools';
import { mktBridgeCallHandler } from '@/utils/instantLoaded/toolsWithoutDeps';
import { UserSessionStatus } from '@shopee/shopee-chatbot-agent-chat/dist/types';
import { getLiveChatSDKBridgeParams } from '../liveChatToken';
import { isBank } from '@/config/core';

// 0(in-queue) / 1(in-chat) / 3(chat-end)
export enum ChatStatus {
  // 0(in-queue)
  InQueue = 0,
  // 1(in-chat)
  InChat = 1,
  // 3(chat-end)
  ChatEnd = 3,
}

export type Params = {
  queuing_avatar?: string;
  agent_avatar?: string;
  pooling_domain?: typeof location.origin;
  show?: boolean;
  session_key?: string;
  session_id?: string;
  chat_status?: number;
  status_num?: ChatStatus;
  chat_key?: string;
  chatbot_session_id?: string;
  with_resloved?: boolean;
  sequence?: number;
  entry?: ENTRY;
};
enum BridgeError {
  // SDK error (from main app)
  SDKError = -1,
  // Success
  Success = 0,
  // Failed
  Failed = 1,
}

export enum ENTRY {
  CHATBOT = 'chatbot',
  AGENT = 'agent',
}

export function toggleShow(params: Params) {
  return new Promise((resolve) => {
    bridgeCallFunc(() => {
      const { sessionID, sessionKey, position, shopeeChatKey, connectPremiumLiveChatDirectly, queuePositionMax, isSupportFloatingBubble, apiBaseUrl } = agentStore;
      const { queuing_avatar, agent_avatar } = getFloutingBubbleAvatars();
      const { sessionId: chatbotSessionId } = initStore;
      if (!isSupportFloatingBubble) {
        resolve({});
        return;
      }
      window.bridgeCallHandler(
        'sendDataToFloatingChatBubble',
        {
          chatData: JSON.stringify({
            action: 'toggleShow',
            data: {
              // 直接进线的 Premium User 不展示排队头像
              queuing_avatar,
              agent_avatar,
              pooling_domain: apiBaseUrl || location.origin,
              session_key: sessionKey,
              session_id: sessionID,
              chat_status: position ? 0 : 1, // 0(in-queue) / 1(in-chat)
              status_num: position ? position : 0, // (queue-seq-num / unread-msg-num)
              chat_key: shopeeChatKey,
              queue_position_max: queuePositionMax,
              entry: ENTRY.AGENT,
              chatbot_session_id: chatbotSessionId,
              with_resloved: false,
              ...getLiveChatSDKBridgeParams(),
              ...params,
            },
          }),
        },
        function (res: {
          error: BridgeError;
          // Debug message
          errorMessage: string;
          data: {};
        }) {
          resolve(res);
        },
      );
    });
  });
}

export function updateBubbleStatus(params: { chat_status: UserSessionStatus; show: boolean }) {
  const { sessionID, sessionKey, position, shopeeChatKey, connectPremiumLiveChatDirectly, isSupportFloatingBubble, apiBaseUrl } = agentStore;
  const { queuing_avatar, agent_avatar } = getFloutingBubbleAvatars();
  if (!isSupportFloatingBubble) {
    return;
  }
  mktBridgeCallHandler('sendDataToFloatingChatBubble', {
    chatData: JSON.stringify({
      action: 'updateStatus',
      data: {
        session_key: sessionKey,
        queuing_avatar,
        agent_avatar,
        pooling_domain: apiBaseUrl || location.origin,
        session_id: sessionID,
        status_num: position ? position : 0, // (queue-seq-num / unread-msg-num)
        chat_key: shopeeChatKey,
        ...getLiveChatSDKBridgeParams(),
        ...params,
      },
    }),
  });
}

function getImage(url: string) {
  try {
    new URL(url);
    return url;
  } catch (e) {
    return `${location.origin}${url}`;
  }
}

function getFloutingBubbleAvatars() {
  if (isBank()) {
    return {
      queuing_avatar: getImage(initStore.queueAvatar),
      agent_avatar: getImage(initStore.chattingAvatar),
    };
  }

  return {
    queuing_avatar: getImage(agentStore.connectPremiumLiveChatDirectly ? initStore.agentAvatar : initStore.botAvatar),
    agent_avatar: getImage(initStore.agentAvatar),
  };
}
